import type { LangToggleContent } from "../types";

export const langToggle: LangToggleContent = {
  ariaLabel: "Language",
  targetLabel: "DA",
  targetName: "Danish",
};
